<template>
    <v-row justify="center" align="center" class="row">
      <v-col
        cols="6"
        sm="12"
        md="6"
        xs="12"
        class="text-center"
      >
      <v-col cols="12">
        <v-btn icon title="Usuarios" 
          aria-label="Usuarios"
        >
          <v-icon 
              size="60">
              fas fa-clipboard-check
          </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" class="mt-1">
        <!-- <span
          class="font-weight-bold leading--text mb-3"
          :style=
            "$vuetify.breakpoint.xs ? 'font-size: 25px' : 'font-size: 32px'"
        >{{usuarioConfig.desdeListado ? 'Administración de Usuario':'Registro de Usuario'}}</span> -->
        <span
          class="font-weight-bold leading--text mb-3"
          :style=
            "$vuetify.breakpoint.xs ? 'font-size: 25px' : 'font-size: 32px'"
        >{{usuarioConfig.desdeListado ? 'Administración de Usuario':'Registro de Usuario'}}</span>
        <br />
        <!-- <span :class="$vuetify.breakpoint.xs ? 'font-weight-regular body-1' : 'font-weight-regular title'">Aqui encontrará la manera más fácil de consultar su proceso</span> -->

        <!-- <v-row>
        </v-row>-->
      </v-col>

        <v-form ref="form" class="my-2" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12">
              <v-text-field
                :value="datos.usuario"
                label="Usuario"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="datos.nombres"
                label="* Nombres"
                maxlength="30"
                required
                :rules="nombresRules"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="datos.apellidos"
                label="* Apellidos"
                maxlength="30"
                required
                :rules="apellidosRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
                <v-text-field
                    v-model="datos.telefono"
                    label="Teléfono"
                    maxlength="20"
                ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="datos.celular"
                label="* Celular"
                maxlength="20"
                :rules="celularRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="usuarioConfig.desdeListado">
            <v-col cols="4">
                <v-checkbox
                    v-model="datos.activo"
                    label="Activo"
                ></v-checkbox>
            </v-col>
          </v-row>
          <!-- <v-btn class="purple darken-2 white--text mt-5"  @click="submitForm"> 
            Register
          </v-btn> -->
          <div class="mt-2 ">
            <v-btn
              :loading="loading"
              color="success"
              :class="
                `${$vuetify.breakpoint.xs ? 'mt-4 ' : ' '} mx-2 font-weight-bold`
              "
              width="200"
              aria-label="Guardar cambios"
              @click="guardar"
              >Guardar</v-btn
            >
              <!-- dark -->
            <v-btn
              :class="
                `${$vuetify.breakpoint.xs ? 'mt-4 ' : ' '} mx-2 font-weight-bold`
              "
              width="200"
              color="grey"
              @click="cancelar"
              aria-label="Cancelar cambios"
              >Cancelar</v-btn
            >
            <!-- <v-btn
              :class="
                `${$vuetify.breakpoint.xs ? 'mt-4 ' : ' '} mx-2 font-weight-bold`
              "
              width="200"
              color="grey"
              @click="test"
              aria-label="Test cambios"
              >Test</v-btn
            > -->
          </div>          

        </v-form>
      </v-col>
    </v-row>
</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from 'vuex'
export default {
  name: "MainAccesoUsuario",
  props:{
    id:{
      type: Number,
      default: 0
    }
  },  
  data: () => ({
    loading: false,
    valid: true,
    // idUsuario: '',
    datos: {
      idUsuario: null,
      usuario: '',
      nombres: '',
      apellidos: '',
      telefono: '',
      celular: '',
      activo: null,
      deCPNU: null,
    },
    nombresRules: [
      v => !!v || 'Se han de ingresar los nombres.'
      // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],
    apellidosRules: [
      v => !!v || 'Se han de ingresar los apellidos.'
      // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],
    celularRules: [
      v => !!v || 'Se ha de ingresar el celular.'
      // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],
  }),
  methods: {
    ...mapActions('acceso',['fetchUsuario', 
      'postUsuario', 'putUsuario', 'putUsuarioAdmin']),
    ...mapMutations('auth',['SetNombre']),
    submitForm () {
      this.$refs.form.validate();
    },
    async guardar(){
      if (this.$refs.form.validate()) {
        console.log(this.datos)
        // Complementar datos para invocación de EndPoint
        this.datos.idUsuario = this.datos.idUsuario || null
        this.datos.deCPNU = this.datos.deCPNU || null
        // // // console.log(this.datos)
        // // // console.log(this.usuarioConfig)

        // Guardar datos en el arreglo
        
        if (this.usuarioConfig.esNuevoEditar){
          await this.postUsuario(this.datos)
          // Actualizar nombre que aparece al autenticarse
          
          this.SetNombre(this.datos.nombres)
          this.$router.push("/")            
        }
        else{
          console.log(this.usuarioConfig)
          console.log(this.datos)
          if(this.usuarioConfig.desdeListado){
            
            this.datos.activo = this.datos.activo || false
            await this.putUsuarioAdmin(this.datos)
          }
          else{
            
            await this.putUsuario(this.datos)
          }
        }
        // Si se está editando desde listado, regtresar al listado
        if (this.usuarioConfig.desdeListado){
          this.$router.go(-1)
        }
        // Si lo edita el usuario, ir al menú pricipal
        else{
          
          this.$router.push("/")            
        }
      }
    },
    cancelar(){
      // Si se esta agregando Regresar a la vista de LoginToken
      if (this.usuarioConfig.esNuevoEditar){
        this.$router.go(-1)
      // Si se esta editando, ir al menú principal
      }else{
        this.$router.push('/')
      }
    },
    test(){
      this.datos = this.usuario
      console.log("test() this.usuario", this.usuario)
      console.log("test() this.datos", this.datos)
    } 
  },
  computed:{
    ...mapState('acceso',['usuarioConfig', 'usuario']),
    ...mapGetters('acceso', ['getUsuarios']),
  },
  created: async function(){
    console.log(this.usuarioConfig)
    if (!this.usuarioConfig.esNuevoEditar){
      // Si se trae del listado 
      if (this.usuarioConfig.desdeListado){
        // Traer los datos del listado        
        this.datos=this.getUsuarios[this.usuarioConfig.indiceListado]
        console.log("this.datos - Listado", this.datos)
      }
      // Si no se trae de listado
      else{
          // Los datos son cargados desde la vista de LoginToken
          this.datos = this.usuario
          console.log("this.datos - Ingresando a vista Usuario", this.datos)
      }
    // Si se está agregando
    }else{
      // Inicalizar el email con el ingresado antes de solicitar el token
      this.datos={
        usuario: this.usuarioConfig.email
      }       
    }    
  }
};
</script>
